import Api from '@/services/Api';

export default {
  getMealTags() {
    return Api().get('tags/meal', {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  createMealTag(tagName: string) {
    return Api().post('tags/create/meal', {name: tagName}, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  removeMealTag(tag: string, foodid: string) {
    return Api().delete(`tags/meal/${tag}/${foodid}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  deleteMealTag(tagName: string) {
    return Api().delete(`tags/meal/${tagName}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
};
